import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@pwc/appkit-react/lib/Banner';

const WarningBanner = ({ warningMessage }) => warningMessage
  ? (
    <div className="tax-expense-draft-banner">
      <Banner status="warning" content={warningMessage} />
    </div>
  )
  : null;

WarningBanner.propTypes = {
  warningMessage: PropTypes.node,
};

export default WarningBanner;
